module.exports = __webpack_public_path__ + "img/cpxx.cf4d8ac0.png";